export function ComponentReferencesHoverCard({
  children,
}: {
  componentId: string;
  children: React.ReactNode;
  currentTestContentId: string;
}) {
  return <>{children}</>;
}
